// Safely turn a Firestore Timestamp | {seconds} | Date | ISO string into a JS Date.
// Real Firestore docs store dates as Timestamps, so `new Date(timestamp)` yields
// "Invalid Date" — always normalize through here before formatting/sorting.
export const toJsDate = (v) => {
  if (!v) return null;
  if (typeof v.toDate === 'function') return v.toDate();
  if (typeof v.seconds === 'number') return new Date(v.seconds * 1000);
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (v, fallback = '') => {
  const d = toJsDate(v);
  return d ? d.toLocaleDateString() : fallback;
};
